// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 679) return "static/chunks/679-0fdc5d8cd8f84b3b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"451":"1edf0483","798":"88edb295"}[chunkId] || chunkId) + "." + {"208":"258391f19bee1869","451":"9dfe51f2fe978bc8","651":"6b0a0a214e3e799c","741":"a83780b663de33f6","798":"26e57c732e8c0ee3","918":"9c725618c4e6c2d9"}[chunkId] + ".js";
};